import * as TK from 'components/auth/ResetPasswordDialog/translations/constants';
import { Translations } from 'translations/types';

export const resetPasswordDialogEnUsLocale: Translations = {
  [TK.RESET_PASSWORD_DIALOG_TITLE]: 'Password Reset Successfully',
  [TK.RESET_PASSWORD_DIALOG_BUTTON_TEXT]: 'Go to home',
  [TK.RESET_PASSWORD_DIALOG_ICON_ALT]: 'Done icon',
};
